import { OneDriveItem } from '../dms/onedrive-list/onedrive-item.type';
import { zDoxItem } from "./types";

declare const serviceUrl: string;

export class Mimetype {
   static getIcon(item: zDoxItem, trash?: boolean): string {
      if (!item?.mimeType && !item?.isFolder) {
         return 'assets/icons/file.svg';
      }
      if (item.isFolder) {
         return 'assets/icons/folder.svg';
      }
      if (this.hasThumbnail(item, trash)) {
         return this.getThumbnailUrl(serviceUrl, item.thumbnail);
      }
      if (item.mimeType.indexOf('image/') === 0) {
         return 'assets/icons/image.svg';
      }
      if (item.mimeType.indexOf('audio/') === 0) {
         return 'assets/icons/audio.svg';
      }
      if (item.mimeType.indexOf('video/') === 0) {
         return 'assets/icons/video.svg';
      }
      if (item.name.endsWith('.zdox') || item.type?.toLowerCase().includes('zdox')) {
         return 'assets/icons/zdox_eform.png';
      }
      switch (item.mimeType) {
         case 'application/msword':
         case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'assets/icons/docx.svg';
         case 'application/vnd.ms-excel':
         case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'assets/icons/xlsx.svg';
         case 'application/vnd.ms-powerpoint':
         case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'assets/icons/pptx.svg';
         case 'application/pdf':
            return 'assets/icons/pdf.png';
         case 'application/zip':
            return 'assets/icons/archive.svg';
         case 'text/plain':
            return 'assets/icons/text.svg';
         case 'application/xml':
         case 'text/xml':
            return 'assets/icons/xml.svg';
         case 'text/html':
            return 'assets/icons/code.svg';
         case 'message/rfc822':
            return 'assets/icons/email.svg';
      }
      if (item.name.endsWith('.7z')) {
         return 'assets/icons/archive.svg';
      }
      return 'assets/icons/file.svg';
   }

   static getIconOneDrive(item: OneDriveItem): string {
      if (!item.file) {
         return 'assets/icons/folder.svg';
      }
      return this.getIconGoogleDrive(item.file)
   }

   static getIconDMSList(mimeType: string, name: string, isFolder: boolean) {
      if (isFolder) {
         return 'assets/icons/folder.svg';
      }
      // ZE-4039: hard code for specific extensions
      if (name.toLowerCase().endsWith('.flv')) {
         return 'assets/icons/video.svg';
      }
      return this.getIconGoogleDrive({ mimeType, name });
   }

   static getIconDropbox(item: any): string {
      const name = item.name.toLowerCase();
      if (name.lastIndexOf('.qcp') > -1 || name.lastIndexOf('.jbig') > -1 || name.lastIndexOf('.jpeg2000') > -1
         || name.lastIndexOf('.pjpeg') > -1 || name.lastIndexOf('.zdox') > -1 || name.lastIndexOf('.tmp') > -1 
         || name.lastIndexOf('.dat') > -1) {
         return 'assets/icons/file.svg';
      }
      else if (item.mimeType === 'application/octet-stream') {
         if(item.name.lastIndexOf('.amp') > -1 || item.name.lastIndexOf('.web') > -1) {
            return 'assets/icons/file.svg';
         } else {
            return 'assets/icons/folder.svg';
         }
      }
      else if (item.mimeType === 'image/vnd.wap.wbmp') {
         return 'assets/icons/file.svg';
      }
      else if (item.mimeType === 'audio/amr') {
         return 'assets/icons/file.svg';
      }
      else {
         return this.getIcon(item,false);
      }
   }

   static getIconGoogleDrive(item: any): string {

      if (!item?.mimeType) {
         return 'assets/icons/file.svg';
      }
      if (item.name?.endsWith('.wbmp')) {
         return 'assets/icons/file.svg';
      }
      if (item.mimeType.indexOf('image/') === 0) {
         return 'assets/icons/image.svg';
      }
      if (item.mimeType.indexOf('audio/') === 0) {
         return 'assets/icons/audio.svg';
      }
      if (item.mimeType.indexOf('video/') === 0) {
         return 'assets/icons/video.svg';
      }
      if (item.name?.endsWith('.ogg')) {
         return 'assets/icons/audio.svg';
      }
      switch (item.mimeType) {
         case 'application/vnd.google-apps.folder':
            return 'assets/icons/folder.svg';
         case 'application/vnd.google-apps.video':
            return 'assets/icons/video.svg';
         case 'application/vnd.google-apps.audio':
            return 'assets/icons/audio.svg';
         case 'application/vnd.google-apps.photo':
            return 'assets/icons/image.svg';
         case 'application/msword':
         case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'assets/icons/docx.svg';
         case 'application/vnd.ms-excel':
         case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'assets/icons/xlsx.svg';
         case 'application/vnd.ms-powerpoint':
         case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'assets/icons/pptx.svg';
         case 'application/pdf':
            return 'assets/icons/pdf.png';
         case 'application/zip':
         case 'application/x-rar':
            return 'assets/icons/archive.svg';
         case 'text/plain':
            return 'assets/icons/text.svg';
         case 'application/xml':
         case 'text/xml':
            return 'assets/icons/xml.svg';
         case 'text/html':
            return 'assets/icons/code.svg';
         case 'message/rfc822':
            return 'assets/icons/email.svg';
         case 'application/vnd.google-apps.shortcut':
            return 'assets/icons/export.png';
         case 'application/vnd.google-apps.spreadsheet':
            return 'assets/icons/xlsx.svg';
         case 'application/vnd.google-apps.document':
            return 'assets/icons/docx.svg';
      }
      return 'assets/icons/file.svg';
   }

   static hasThumbnail(item: zDoxItem, trash?: boolean): boolean {
      const mimeType = item.mimeType;
      return !trash && item.thumbnail
         && (mimeType === 'image/jpeg' || mimeType === 'image/png'
            || mimeType === 'image/gif' || mimeType === 'image/bmp'
            || mimeType === 'image/tiff' || mimeType === 'image/jp2'
            || mimeType === 'image/vnd.adobe.photoshop'
            || mimeType === 'application/eps');
   }

   static hasPreview(mimeType: string): boolean {
      return mimeType && (mimeType === 'image/jpeg' || mimeType === 'image/png'
         || mimeType === 'image/gif' || mimeType === 'image/bmp'
         || mimeType === 'image/tiff' || mimeType === 'image/jp2'
         || mimeType === 'image/vnd.adobe.photoshop'
         || mimeType === 'application/eps'
         || mimeType === 'application/pdf'
         || mimeType === 'application/msword'
         || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
         || mimeType === 'application/vnd.ms-excel'
         || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
   }

   private static getThumbnailUrl(p1: string, p2: string): string {
      if (p1[p1.length - 1] === '/' || p2[0] === '/') {
         return p1 + p2;
      }
      return p1 + '/' + p2;
   }

   static canEdit(item: any): boolean {
      if (item.isFolder || !item.permissions.write) {
         return false;
      }
      if (item.mimeType === 'application/msword'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
         || item.mimeType === 'application/vnd.ms-excel'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         || item.mimeType === 'application/vnd.ms-powerpoint'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
         if (item.mimeType === 'application/msword'
            || item.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            item.openWith = 'Word Online';
            item.openWithIcon = 'assets/icons/ms-word.svg';
            item.openWithGoogle = 'Google Docs';
            item.openWithIconGoogle = 'assets/icons/google_doc.svg';
         } else if (item.mimeType === 'application/vnd.ms-excel'
            || item.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            item.openWith = 'Excel Online';
            item.openWithIcon = 'assets/icons/ms-excel.svg';
            item.openWithGoogle = 'Google Sheets';
            item.openWithIconGoogle = 'assets/icons/google_sheet.svg';
         } else if (item.mimeType === 'application/vnd.ms-powerpoint'
            || item.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
            item.openWith = 'PowerPoint Online';
            item.openWithIcon = 'assets/icons/ms-powerpoint.svg';
         }
         return true;
      }
      return false;
   }

   // Sign-Off Document
   static canSign(item: any): boolean {
      if (item.isFolder || !item.permissions.write) {
         return false;
      }
      return item.mimeType === 'application/pdf';
   }

   static canPrint(item: any): boolean {
      return (item.mimeType === 'application/pdf' || item.mimeType === 'application/msword'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
         || item.mimeType === 'application/vnd.ms-excel'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         || item.mimeType === 'application/vnd.ms-powerpoint'
         || item.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation');
   }

   static validateExtension(v : any,typeName : any, platform?: string): boolean  {
      let allowedExtensions: string[];
      if (typeName === 'template') {
         allowedExtensions = ['application/pdf', 'text/xml'];
         if (platform === 'dropbox') {
            allowedExtensions.push('application/octet-stream');
         }
      } else {
         allowedExtensions = ['image/bmp', 'application/msword', 'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/jpeg', 'image/png', 'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'text/plain', 'image/tiff', 'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.oasis.opendocument.text', 'text/xml', 'application/octet-stream'];
      }
      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }
   static checkMimeType(mimeType: string): string{
      if (!mimeType) return '';
      if (mimeType === 'application/pdf'
         || ((mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            || mimeType === 'application/msword'
            || mimeType === 'application/vnd.ms-excel'
            || mimeType === 'image/tiff'
            || mimeType === 'application/vnd.ms-powerpoint'
            || mimeType === 'application/vnd.oasis.opendocument.text'
            || mimeType === 'application/octet-stream'))) {
         return 'doc';
      } else if (mimeType === 'image/jpeg' || mimeType === 'image/png' || mimeType === 'image/bmp') {
         return 'img';
      }  else if (mimeType.indexOf('text/') === 0) {
         return 'text';
      } else {
         return '';
      }
   }
}
